<template>
	<section class="Bizki" style="display: none;"></section>
</template>

<script>
	import { waitUntil } from '../../common/libs/utils';

	let wrapper, img;

	export default {
		mounted() {
			this.$store.state.bot = { ...this.$store.state.bot, widget_thumb: 'https://botdv.s3.amazonaws.com/530_widget_thumb.png?&t=1608185490' };

			(async () => {
				let container = await waitUntil(() => document.querySelector('#app .Widget .Chats'));
				let sizeMultifier = 1;

				const video = document.createElement('video');
				let source = document.createElement('source');
				source.src = 'https://botdv.s3.amazonaws.com/1606289355_0.webm';
				source.type = 'video/webm';
				video.append(source);

				source = document.createElement('source');
				source.src = 'https://botdv.s3.amazonaws.com/1606356457_0.mp4';
				source.type = 'video/mp4';
				video.append(source);

				video.autoplay = true;
				video.muted = true;
				video.defaultMuted = true;
				video.controls = true;
				video.playsinline = true;
				video.setAttribute('playsinline', true);
				video.loop = true;

				wrapper = document.createElement('div');
				wrapper.classList.add('header-video');
				wrapper.append(video);

				video.playsinline = true;

				video.addEventListener(
					'loadedmetadata',
					function(e) {
						wrapper.style.setProperty('--ratio', this.videoWidth / this.videoHeight);
					},
					false
				);

				container.insertAdjacentElement('afterbegin', wrapper);

				container.addEventListener('scroll', e => {
					const start = 50;
					const max = 350;
					const minSize = 0.5;

					const size =
						(1 - minSize + minSize * Math.min(Math.max((max - Math.max(e.target.scrollTop - start, 0)) / (max - start), 0), 1)) *
						sizeMultifier;
					wrapper.style.setProperty('--size', size);
				});

				console.log(this.parseJSON(JSON.stringify(this.$store.state.bot)));

				// container = await waitUntil(() => document.querySelector('#app .Widget'));
				// img = document.createElement('img');
				// img.src = 'https://botdv.s3.amazonaws.com/530_1606294041_0.png';
				// img.classList.add('footer-girl');
				// container.append(img);
			})();
		},

		destroyed() {
			wrapper && wrapper.remove();
			img && img.remove();
		}
	};
</script>

<style lang="scss">
	body[data-client='bizki'] {
		#app {
			.Widget {
				.header-video {
					--ratio: 2;
					--size: 1;
					margin: 0 -1.6rem;
					flex: 0 0 20rem;
					position: sticky;
					top: 0;
					z-index: 1;
					transform: translateY(-1.6rem) scale(var(--size));
					transform-origin: top left;

					&::after {
						content: '';
						margin-top: calc(var(--ratio) * 100%);
					}

					video {
						height: 100%;
						width: 100%;
					}
				}

				.footer-girl {
					display: block;
					position: absolute;
					bottom: 0;
					right: 0;
					width: 12rem;
					pointer-events: none;
				}

				.Header {
					display: none;
				}

				.Input {
					display: none;
				}

				.chat-log {
					.Chats {
						padding-bottom: 16rem;

						.Entry {
							&:not(.bot) {
								display: none;
							}

							.container {
								.avatar {
									border-radius: 0;
									border: none;
									width: 8.4rem;
									height: 7.6rem;
									flex: 0 0 7.6rem;
									background-color: transparent;
									align-self: flex-start;
									margin-top: 4rem;

									@include response(480px) {
										display: none;
									}

									.Thumb {
										background-color: transparent;
										border-radius: 0;
										border: none;
										width: 8.4rem;
										height: 7.6rem;

										img {
											object-fit: contain;
										}
									}
								}

								.message {
									@include response(480px) {
										max-width: calc(100% - 2rem);
									}
									.content {
										background-color: #333;
										color: white;
										overflow: visible;
										margin-bottom: 2.5rem;

										.text {
											position: relative;
											overflow: visible;

											&::after {
												content: '';
												position: absolute;
												display: block;
												background-image: url("data:image/svg+xml,%3Csvg width='44' height='25' viewBox='0 0 44 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M42.6715 20.7424C27.2213 10.2136 30.3625 0 30.3625 0H0C0 0 11.6395 21.062 41.5322 24.5218C43.6287 24.7644 44.4155 21.9309 42.6715 20.7424Z' fill='%23333333'/%3E%3C/svg%3E");
												background-position: center;
												background-repeat: no-repeat;
												width: 5rem;
												height: 2.5rem;
												bottom: 0;
												right: 1rem;
												transform: translateY(100%);
											}
										}

										.Carousel {
											.Button {
												background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.2));

												&:hover {
													background-color: var(--clrTheme);
													filter: brightness(1.2);
												}

												&:nth-child(2) {
													background-color: #999;
												}
											}
										}

										&[data-app='payment'] {
											background-color: white;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>
